module.exports = __webpack_public_path__ + "assets/images/PowerDMS-Footer-Logo-color.png";